import React, { useState } from 'react';
import Table from 'partial/components/Table';
import Pagination from 'partial/components/Pagination';
import { useAdminRecentMessages } from '../hooks';

const format = [
  {
    label: 'AGENCY NAME',
    key: 'organization_name',
    labelClassName: 'whitespace-nowrap',
  },
  { label: 'MASK NAME', key: 'mask_name', labelClassName: 'whitespace-nowrap' },
  {
    label: 'SMS COUNT',
    key: 'sms_count',
    labelClassName: 'whitespace-nowrap text-center',
    contentClassName: 'text-center tabular-nums',
  },
  {
    label: 'RECORDS',
    key: 'records',
    labelClassName: 'whitespace-nowrap text-center',
    contentClassName: 'text-center tabular-nums',
  },
  {
    label: 'TOTAL MESSAGES',
    key: 'total_messages',
    labelClassName: 'whitespace-nowrap text-center',
    contentClassName: 'text-center tabular-nums',
  },
];

function RecentMessages() {
  const [filter, setFilter] = useState({ per_page: 10 });
  const [isLoading, data, meta] = useAdminRecentMessages(filter);

  const setPage = (v) => setFilter((f) => ({ ...f, ...v }));

  return (
    <div className="bg-white border border-neutral-200 rounded-md overflow-hidden">
      <div className="p-4 sm:p-6 border-b border-neutral-200">
        <h3 className="text-base font-semibold leading-6 text-neutral-900">
          Recent Messages
        </h3>
      </div>
      <Table data={data} format={format} isLoading={isLoading} />
      <div className="p-4 sm:p-6 border-t border-neutral-200">
        <Pagination value={meta} onChange={setPage} />
      </div>
    </div>
  );
}

export default RecentMessages;
